module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.element, {
    tag: "div",
    staticClass: "VimeoThumbnail",
    style: (_vm.vimeoThumbnailStyle),
    attrs: {
      "to": _vm.route || ''
    }
  }, [_c('thumbnail', {
    staticClass: "VimeoThumbnail-thumbnail",
    attrs: {
      "image": _vm.resolvedImage,
      "tags": _vm.resolvedTags,
      "button": _vm.resolvedButton
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc4d2af2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VimeoThumbnail.vue
// module id = 796
// module chunks = 1474